export function getLimitedAt(pass, book) {
  if (pass.is_valid) {
    return pass.user_limited_at;
  }
  return book.user_started_at
    ? book.user_limited_at
    : book.available_limited_at;
}
